var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottie-vue-player',{staticClass:"confetti",attrs:{"src":_vm.source,"player-controls":false,"autoplay":""}})}
var staticRenderFns = []

export { render, staticRenderFns }